export default __webpack_public_path__ + "static/media/camb_logo_coloured.e184436c.svg";